var firebaseConfig={
  "apiKey": "AIzaSyCItqCaaYOtFeh57Lf1ukD2hVEYAItdqbI",
  "authDomain": "appbuilder-dc4f6.firebaseapp.com",
  "databaseURL": "https://appbuilder-dc4f6.firebaseio.com",
  "projectId": "appbuilder-dc4f6",
  "storageBucket": "appbuilder-dc4f6.appspot.com",
  "messagingSenderId": "709452306122",
  "appId": "1:709452306122:web:3b0a46126f193028388633"
};
exports.config=firebaseConfig;


// WEBPACK FOOTER //
// ./src/config/firebase_config.js